function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#1A1B26;}\n\t.st1{fill:#F3DC1D;}\n\t.st2{fill:#E8E4DB;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  className: "st0",
  cx: 256,
  cy: 256.1,
  r: 256
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M368.2,322.9c-55.4,27.2-122.5,4.1-149.3-51.6c-26-54.1-4-119.8,49.4-147.2c0.7-0.4,1.4-0.7,2.1-1.1 c4.9-2.4,3.6-9.8-1.9-10.4c-26.2-2.8-53.5,1.7-78.8,14.3c-69.9,34.8-99.1,120.2-65.1,190.5c34.6,71.7,120.9,101.4,192.3,66.4 c25.1-12.3,45-31.1,58.7-53.2c2.9-4.7-2.2-10.2-7.2-7.8C368.3,322.9,368.2,322.9,368.2,322.9z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("circle", {
  className: "st2",
  cx: 355.9,
  cy: 100.9,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 316.7,
  cy: 182.9,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 384.7,
  cy: 414.4,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 252.5,
  cy: 39.8,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 232.1,
  cy: 356.4,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 104.2,
  cy: 374.6,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 159.3,
  cy: 447.7,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 426.6,
  cy: 296.5,
  r: 8.9
}), React.createElement("circle", {
  className: "st2",
  cx: 176.1,
  cy: 190.8,
  r: 8.9
}));

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M421.8,143.2c9.8-0.7,19.2-2.8,28-6.3c-8.8-3.5-18.1-5.6-28-6.3c-0.7-9.8-2.8-19.2-6.3-28 c-3.5,8.8-5.6,18.1-6.3,28c-9.8,0.7-19.2,2.8-28,6.3c8.8,3.5,18.1,5.6,28,6.3c0.7,9.8,2.8,19.2,6.3,28 C418.9,162.4,421.1,153,421.8,143.2z"
});

var SvgDark = function SvgDark(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dark.aafdc75a.svg";
export { ForwardRef as ReactComponent };